const GIGABYTE = 1_000_000_000n;

/** Decimal gigabytes without a unit. Exact gigabytes stay whole; otherwise one decimal place. */
export function formatStorageGigabyteAmount(bytes: bigint): string {
  const magnitude = bytes < 0n ? -bytes : bytes;
  if (magnitude === 0n) return "0";
  const whole = magnitude / GIGABYTE;
  const remainder = magnitude % GIGABYTE;
  let tenth = (remainder * 10n + GIGABYTE / 2n) / GIGABYTE;
  let shown = whole;
  if (tenth >= 10n) {
    shown += 1n;
    tenth = 0n;
  }
  if (tenth === 0n) return shown.toString();
  return `${shown.toString()}.${tenth.toString()}`;
}
